function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "linkedin");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-229.000000, -99.000000)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(170.000000, 99.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(59.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21,0 C32.5979797,0 42,9.40202025 42,21 C42,32.5979797 32.5979797,42 21,42 C9.40202025,42 0,32.5979797 0,21 C0,9.40202025 9.40202025,0 21,0 Z M29.0953244,11 L12.9046756,11 C11.8517579,11 11,11.8535701 11,12.9046756 L11,12.9046756 L11,29.0953244 C11,30.1464299 11.8517579,31 12.9046756,31 L12.9046756,31 L29.0953244,31 C30.1482421,31 31,30.1464299 31,29.0953244 L31,29.0953244 L31,12.9046756 C31,11.8535701 30.1482421,11 29.0953244,11 L29.0953244,11 Z",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.1366437,22.7651323 C28.1366437,20.2624139 26.8408844,18.8669808 24.9942008,18.8669808 C23.5027184,18.8669808 22.8394346,19.6607466 22.4661109,20.2152954 L22.4661109,19.0590794 L19.5737586,19.0590794 C19.6100036,19.822037 19.5737586,27.4334904 19.5737586,27.4334904 L22.4661109,27.4334904 L22.4661109,22.8847408 C22.4661109,22.6418992 22.4860457,22.3990576 22.560348,22.2250816 C22.7615078,21.7393983 23.2236318,21.2355926 23.9974628,21.2355926 C25.0141356,21.2355926 25.3312794,21.9822399 25.3312794,23.0768394 L25.3312794,27.4334904 L28.1366437,27.4334904 L28.1366437,22.7651323 Z"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "14.7114897 27.4334904 17.4226169 27.4334904 17.4226169 18.9992751 14.7114897 18.9992751"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.92751,15.2787242 C15.1065603,15.2787242 14.5701341,15.891265 14.5701341,16.6959043 C14.5701341,17.4842334 15.0902501,18.1130845 15.8967017,18.1130845 L15.913012,18.1130845 C16.7484596,18.1130845 17.2703878,17.4842334 17.2703878,16.6959043 C17.2540776,15.891265 16.7484596,15.2787242 15.92751,15.2787242 L15.92751,15.2787242 Z"
}))))));

var SvgLinkedin = function SvgLinkedin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkedin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/linkedin.cd7c0d2c.svg";
export { ForwardRef as ReactComponent };